export enum GTMRecentlyDeletedInteractionAction {
  RESTORED = 'Restored',
  REMOVED = 'Removed',
}
